'use client';
import { Tooltip } from 'tdesign-react';
// import { SectionContainer } from '../component/SectionContainer';
import { ChevronLeftIcon, ChevronRightIcon } from 'tdesign-icons-react';
import Tabs, { TabPane } from '../_bs-components/TabCarousel';
import TabTitle from '../_bs-components/TabTitle';
import { ExhibitionAreaItem } from '../type';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useLocale } from 'use-intl';
import { getCMSIntlVal } from '../utils/common';
import Image from '../../../image';

const ExhibitionAreaInfoCard = ({
  className = '',
  item,
  onNext,
  onPrev,
}: {
  className?: string;
  item?: ExhibitionAreaItem;
  onNext?: () => void;
  onPrev?: () => void;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    containerRef.current?.scrollTo(0, 0);
  }, [item]);
  const { name, tag, tContent, imgUrl } = item || {};
  const tagList = tag?.split(';') || [];
  return (
    <div className={`relative group ${className}`}>
      <div
        ref={containerRef}
        className={`text-white w-[462px] pr-1 py-[32px] mobile:w-full mobile:p-[24px]`}
        style={{
          background:
            'url(https://cdn-digital.ssv.qq.com/upload//s2025/1762244082048/area-info-bg.png) no-repeat center center/cover',
        }}
      >
        <div className="w-full h-full pl-10 pr-9 max-h-[656px] mobile:max-h-full overflow-y-auto scrollbarStyle1 touch-pan-y mobile:pl-0 mobile:pr-0">
          <h5 className="text-[28px] leading-[1.5] mobile:text-[16px] break-words">
            {name}
          </h5>
          <div className="hidden mobile:block">
            <div className="flex flex-row flex-nowrap gap-1 overflow-x-auto scrollbar-hidden mt-2">
              {tagList.map((tag, index) => {
                return (
                  <div
                    key={index}
                    className="px-2 py-[2px] text-white/80 text-xs font-300 flex-shrink-0"
                    style={{
                      background:
                        'linear-gradient(270deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.35) 100%)',
                    }}
                  >
                    {tag}
                  </div>
                );
              })}
            </div>
          </div>
          <Image
            className="h-[212px] my-5 mobile:mb-0 mobile:h-[159px]"
            src={imgUrl || ''}
            loading="lazy"
            width={462}
            height={212}
            alt={'Exhibition Area Image'}
          />

          <div className="flex items-center mobile:hidden">
            <div className="flex-1 flex flex-row flex-nowrap gap-2 overflow-x-auto scrollbar-hidden">
              {tagList.map((tag, index) => {
                return (
                  <div
                    key={index}
                    className="px-3 py-1 text-white/80 text-base flex-shrink-0"
                    style={{
                      background:
                        'linear-gradient(270deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.35) 100%)',
                    }}
                  >
                    {tag}
                  </div>
                );
              })}
            </div>
          </div>

          {tContent?.map((item, index) => {
            const { title, pList } = item || {};
            return (
              <div key={index} className="pt-8">
                <h6 className="text-lg mb-2 mobile:text-xs">{title}</h6>
                {pList.map((item, sindex) => {
                  return (
                    <p
                      key={sindex}
                      className="text-base leading-[1.7] text-white/80 font-300 mobile:text-xs"
                    >
                      {item}
                    </p>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
      <div
        className="group-hover:visible invisible absolute left-2 top-1/2 -translate-y-1/2 size-6 flex items-center justify-center text-white flex-shrink-0 cursor-pointer rounded-full bg-[#FFFFFF1A] hover:bg-[#FFFFFF33] hover:border-[0.5px] hover:border-solid hover:border-white mobile:hidden"
        onClick={onPrev}
      >
        <ChevronLeftIcon></ChevronLeftIcon>
      </div>
      <div
        className="group-hover:visible invisible absolute right-2 top-1/2 -translate-y-1/2 size-6 flex items-center justify-center text-white flex-shrink-0 cursor-pointer rounded-full bg-[#FFFFFF1A] hover:bg-[#FFFFFF33] hover:border-[0.5px] hover:border-solid hover:border-white mobile:hidden"
        onClick={onNext}
      >
        <ChevronRightIcon></ChevronRightIcon>
      </div>
    </div>
  );
};

const AreaItem = ({
  item,
  className = '',
  style = {},
  contentClassName,
  active = false,
  onClick,
}: {
  item: Pick<ExhibitionAreaItem, 'id' | 'title' | 'areaNumber'>;
  className?: string;
  contentClassName?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  active?: boolean;
}) => {
  const { title = '' } = item || {};
  return (
    <Tooltip
      content={title.replace(/\\n/g, '')}
      destroyOnClose
      showArrow
      theme="default"
    >
      <div
        className={`select-none flex items-center justify-center cursor-pointer border rounded-[5px] border-[#FFFFFF4D] bg-[#FFFFFF33] hover:bg-[#FFFFFF99] hover:shadow-[0_4px_20px_0_#B3A0FD40] overflow-hidden ${
          active
            ? 'bg-[#FFFFFF99] shadow-[0_4px_20px_0_#B3A0FD40] border-[4px] border-[transparent]'
            : ''
        } ${className}`}
        style={{
          ...style,
          ...(active
            ? {
                borderImageSource: 'linear-gradient(to top, #B3A0FD, #6A96FE)',
                borderImageSlice: 1,
                clipPath: 'inset(0 round 5px)',
              }
            : {}),
        }}
        onClick={() => onClick?.()}
      >
        <div
          className={` ${contentClassName} text-lg font-300 text-[#121C59]/50 text-center max-w-[90%] max-h-[90%] break-words line-clamp-2 overflow-hidden whitespace-pre-line`}
        >
          {title.replace(/\\n/g, '\n')}
        </div>
      </div>
    </Tooltip>
  );
};
const ExhibitionAreaPlanMap = ({
  className = '',
  list = [],
  activeKey,
  onChange,
}: {
  onChange: (value: unknown) => void;
  list: Pick<ExhibitionAreaItem, 'id' | 'title' | 'areaNumber'>[];
  activeKey: string;
  className?: string;
}) => {
  // list = [
  //   {
  //     areaNumber: 1,
  //     id: '0',
  //     title: '碳寻制造\n新品发布',
  //   },
  //   {
  //     areaNumber: 2,
  //     id: '1',
  //     title: '公益平台\nAI',
  //   },
  //   {
  //     areaNumber: 3,
  //     id: '2',
  //     title: '野朋友',
  //   },
  //   {
  //     areaNumber: 4,
  //     id: '3',
  //     title: '碳寻\n制造',
  //   },
  //   {
  //     areaNumber: 5,
  //     id: '4',
  //     title: '繁星\n邮筒',
  //   },
  //   {
  //     areaNumber: 6,
  //     id: '5',
  //     title: '企鹅\n读伴',
  //   },
  //   {
  //     areaNumber: 7,
  //     id: '6',
  //     title: '老人\n回忆录',
  //   },
  //   {
  //     areaNumber: 8,
  //     id: '7',
  //     title: '伊利',
  //   },
  //   {
  //     areaNumber: 9,
  //     id: '8',
  //     title: '新基石',
  //   },
  //   {
  //     areaNumber: 10,
  //     id: '9',
  //     title: '健康\n数字人',
  //   },
  //   {
  //     areaNumber: 11,
  //     id: '10',
  //     title: '平安',
  //   },
  //   {
  //     areaNumber: 12,
  //     id: '11',
  //     title: '机器人/\n可穿戴设备',
  //   },
  //   {
  //     areaNumber: 13,
  //     id: '12',
  //     title: '美团',
  //   },
  //   {
  //     areaNumber: 14,
  //     id: '13',
  //     title: '盲人计算机/无障碍电影',
  //   },
  //   {
  //     areaNumber: 15,
  //     id: '14',
  //     title: 'Ai幸福舱',
  //   },
  //   {
  //     areaNumber: 16,
  //     id: '15',
  //     title: '景德镇VR/敦煌AI',
  //   },
  // ];
  // 地形配置
  const areaTabList = [
    {
      areaNumber: 1,
      left: 1215,
      top: 112,
      width: 219,
      height: 267,
    },
    {
      areaNumber: 2,
      left: 1436,
      top: 299,
      width: 220.8,
      height: 107.3,
    },
    {
      areaNumber: 3,
      left: 880,
      top: 350,
      width: 357.9,
      height: 117,
    },
    {
      areaNumber: 4,
      left: 1078,
      top: 615,
      width: 153,
      height: 124,
    },
    {
      areaNumber: 5,
      left: 1178,
      top: 458,
      width: 185,
      height: 121,
    },
    {
      areaNumber: 6,
      left: 1598,
      top: 410,
      width: 131,
      height: 162,
    },
    {
      areaNumber: 7,
      left: 1538,
      top: 525,
      width: 93.6,
      height: 164,
    },
    {
      areaNumber: 8,
      left: 1708,
      top: 325,
      width: 93.6,
      height: 161,
    },
    {
      areaNumber: 9,
      left: 1675,
      top: 642,
      width: 93.6,
      height: 177,
    },
    {
      areaNumber: 10,
      left: 1735,
      top: 526,
      width: 131,
      height: 50,
      className: '!line-clamp-1',
    },
    {
      areaNumber: 11,
      left: 1784,
      top: 566,
      width: 131,
      height: 50,
      className: '!line-clamp-1',
    },
    {
      areaNumber: 12,
      left: 1842,
      top: 440,
      width: 93.6,
      height: 178,
    },
    {
      areaNumber: 13,
      left: 1832,
      top: 605,
      width: 131,
      height: 50,
      className: '!line-clamp-1',
    },
    {
      areaNumber: 14,
      left: 1795,
      top: 703,
      width: 171,
      height: 92,
    },
    {
      areaNumber: 15,
      left: 1916,
      top: 563,
      width: 167,
      height: 92,
    },
    {
      areaNumber: 16,
      left: 1965,
      top: 710,
      width: 131,
      height: 92,
    },
  ];
  return (
    <div
      className={`absolute select-none -top-[158px] left-1/2 -translate-x-1/2 w-[2491px] h-[878px] bg-[url(https://cdn-digital.ssv.qq.com/upload//s2025/s-area-bg1.png)] bg-no-repeat bg-[100%,100%] ${className}`}
    >
      {areaTabList.map((areaTabItem) => {
        const {
          left,
          top,
          width,
          height,
          areaNumber,
          className = '',
        } = areaTabItem;
        const item = list.find(
          (item) => Number(item.areaNumber) === Number(areaNumber)
        );
        if (!item) return null;
        return (
          <AreaItem
            item={item}
            key={item.id}
            active={activeKey === item.id}
            className="absolute left-[1066px] top-[520px] w-[81px] h-[94px] rotate-[-50deg] origin-top-right"
            contentClassName={className}
            onClick={() => {
              onChange(item.id);
            }}
            style={{
              left,
              top,
              width,
              height,
            }}
          ></AreaItem>
        );
      })}
    </div>
  );
};

const ExhibitionAreaInfo = ({ list = [] }: { list: ExhibitionAreaItem[] }) => {
  const tabList = list.map((item) => ({
    id: item.id,
    title: item.title,
    areaNumber: item.areaNumber,
  }));
  const [activeKey, setActiveKey] = useState(tabList[0]?.id || '');
  const currentItem = useMemo(() => {
    return list.find((item) => item.id === activeKey);
  }, [activeKey, list]);

  const handleMapChange = (value: unknown) => {
    setActiveKey(value as string);
  };
  const onNext = (isPrev?: boolean) => {
    const index = list.findIndex((item) => item.id === activeKey);
    const nextIndex = isPrev ? index - 1 : index + 1;
    if (nextIndex >= list.length) {
      setActiveKey(list[0].id);
    } else if (nextIndex < 0) {
      setActiveKey(list[list.length - 1].id);
    } else {
      setActiveKey(list[nextIndex].id);
    }
  };
  return (
    <>
      {/* PC */}
      <div className={`relative flex min-h-[720px] mobile:hidden`}>
        <ExhibitionAreaInfoCard
          className="relative z-[1]"
          item={currentItem}
          onNext={() => {
            onNext();
          }}
          onPrev={() => {
            onNext(true);
          }}
        ></ExhibitionAreaInfoCard>
        <ExhibitionAreaPlanMap
          activeKey={activeKey}
          list={tabList}
          onChange={handleMapChange}
        ></ExhibitionAreaPlanMap>
      </div>
      {/* mobile */}
      <div className={`hidden mobile:block`}>
        <Tabs
          activeKey={activeKey}
          onChange={handleMapChange}
          titleScrollClassName="mobile:ml-5"
          titleContentClassName="mobile:mr-5"
          paneScrollClassName="mobile:px-5"
        >
          {list.map((item) => {
            const title = item.title.replace(/\\n/g, '');
            return (
              <TabPane
                key={item.id}
                tabKey={item.id}
                title={({ isActive }) => {
                  return <TabTitle title={title} isActive={isActive} />;
                }}
              >
                <ExhibitionAreaInfoCard
                  item={item}
                  className="mt-6"
                ></ExhibitionAreaInfoCard>
              </TabPane>
            );
          })}
        </Tabs>
      </div>
    </>
  );
};

export default function MeetingExhibitionAreaSection({
  data = [],
  title,
}: {
  data: ExhibitionAreaItem[];
  title: string;
}) {
  const locale = useLocale();
  const translatedIntlList = useMemo(
    () =>
      data
        .map((item) => {
          const contentObj = JSON.parse(item.content || '{}');
          const tContent = contentObj[locale];
          return {
            ...item,
            title: getCMSIntlVal(item, 'title', locale),
            name: getCMSIntlVal(item, 'name', locale),
            tag: getCMSIntlVal(item, 'tag', locale),
            tContent: tContent || [],
          };
        })
        .sort((a, b) => a.areaNumber - b.areaNumber),
    [data, locale]
  );
  return (
    <div className="relative bg-[linear-gradient(180deg,#D0E5FF_0%,#D0E5FF00_100%)] bg-[100%,800px] mb-[200px] mobile:mb-20 mobile:bg-none">
      {title && (
        <h2
          className={`absolute top-[68px] mobile:top-0 mobile:relative w-full max-w-[1372px] left-1/2 -translate-x-1/2 break-words hyphens-auto text-[56px] leading-[1.5] font-400 text-[#121C59] mb-10 mobile:text-[24px] mobile:mb-6 mobile:!max-w-full mobile:px-5`}
        >
          {title}
        </h2>
      )}
      <div
        className={`w-full overflow-x-auto overflow-y-hidden scrollbarStyle1 last:mb-0 pt-[192px] mobile:bg-none mobile:pt-0 mobile-pb-0 mobile:overflow-hidden`}
      >
        <div
          className={`max-w-[1372px] mx-auto mobile:!max-w-full mobile:!px-0`}
        >
          <ExhibitionAreaInfo list={translatedIntlList}></ExhibitionAreaInfo>
        </div>
      </div>
    </div>

    // <SectionContainer
    //   title={title}
    //   contentClassName="mobile:!px-0"
    //   className="relative pt-[68px] bg-[linear-gradient(180deg,#D0E5FF_0%,#D0E5FF00_100%)] bg-[100%,800px] mobile:bg-none mobile-pt-0 mobile-pb-0 overflow-hidden"
    // >
    //   <ExhibitionAreaInfo list={translatedIntlList}></ExhibitionAreaInfo>
    // </SectionContainer>
  );
}
